import { Dialog, DialogActions, DialogContent, DialogTitle, Grid } from "@mui/material"
import IconButton from '@mui/material/IconButton'
import CloseIcon from '@mui/icons-material/Close'
import { Button, Dropdown } from 'monday-ui-react-core'
import { useContext, useEffect, useMemo } from "react"
import { AuthSessionContext } from "api/AuthSession"

const AddUsersModal = ({open, onClose, onSave, setOrganizationRole, emailList, setEmailList}) => {
    const { IS_OWNER, IS_ADMIN } = useContext(AuthSessionContext)

    const rolesOptions = useMemo(() => {
        if (IS_OWNER) {
            return [
                {value: 1, label: 'Admin'},
                {value: 2, label: 'Owner'},
                {value: 3, label: 'User'}
            ]
        } else if (IS_ADMIN) {
            return [
                {value: 1, label: 'Admin'},
                {value: 3, label: 'User'}
            ]
        }
    }, [IS_OWNER, IS_ADMIN])


    return (
        <>
            <Dialog
                open={open}
                onClose={onClose}
                fullWidth={false}
                maxWidth='lg'
            >
                <DialogTitle>Add Users</DialogTitle>
                <IconButton
                    aria-label='close'
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500]
                    }}
                >
                    <CloseIcon />
                </IconButton>

                <DialogContent>
                    <Grid container>
                        <Grid item xs={12}>
                            <label className='field-label'>
                                Organization Role
                            </label>
                            <Dropdown
                                size={Dropdown.size.SMALL}
                                options={rolesOptions}
                                onChange={setOrganizationRole}
                                clearable={false}
                            />
                        </Grid>
                        <Grid item xs={12} mt={2}>
                            <label className='field-label'>
                                Enter email addresses separated by comma
                            </label>
                            <br/>
                            <textarea
                                style={{width: '100%', resize: 'none'}}
                                value={emailList} 
                                onChange={(event) => setEmailList(event.target.value)} 
                                rows={4}  
     
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button className="cancel" onClick={onClose} marginRight={2}>Cancel</Button>
                    <Button className="success" onClick={onSave} marginRight={2}>Save</Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default AddUsersModal